import type { ApiClient } from '../client';
import { appendPaginationQuery } from '../../../types/pagination';
import type {
  ConvertAdmissionLeadRequest,
  ConvertAdmissionLeadResponse,
  CreateAdmissionCounsellingRequest,
  CreateAdmissionCounsellingResponse,
  CreateAdmissionFollowUpRequest,
  CreateAdmissionFollowUpResponse,
  CreateAdmissionLeadRequest,
  CreateAdmissionLeadResponse,
  ListAdmissionCounsellingQuery,
  ListAdmissionCounsellingResponse,
  ListAdmissionFollowUpsQuery,
  ListAdmissionFollowUpsResponse,
  ListAdmissionLeadAuditsQuery,
  ListAdmissionLeadAuditsResponse,
  ListAdmissionLeadsQuery,
  ListAdmissionLeadsResponse,
  UpdateAdmissionLeadStatusRequest,
} from '../types/admissions';

export function bindAdmissions(client: ApiClient) {
  return {
    async listAdmissionLeads(params?: ListAdmissionLeadsQuery) {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      if (params?.status?.trim()) qs.set('status', params.status.trim());
      if (params?.source?.trim()) qs.set('source', params.source.trim());
      if (params?.search?.trim()) qs.set('search', params.search.trim());
      if (params?.assigned_to_user_id?.trim()) {
        qs.set('assigned_to_user_id', params.assigned_to_user_id.trim());
      }
      const query = qs.toString();
      return client.request<ListAdmissionLeadsResponse>(
        query ? `/admissions/leads?${query}` : '/admissions/leads'
      );
    },

    async createAdmissionLead(body: CreateAdmissionLeadRequest) {
      return client.request<CreateAdmissionLeadResponse>('/admissions/leads', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async updateAdmissionLeadStatus(body: UpdateAdmissionLeadStatusRequest) {
      return client.request<void>('/admissions/leads/status', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async listAdmissionFollowUps(params?: ListAdmissionFollowUpsQuery) {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      if (params?.lead_id?.trim()) qs.set('lead_id', params.lead_id.trim());
      const query = qs.toString();
      return client.request<ListAdmissionFollowUpsResponse>(
        query ? `/admissions/follow-ups?${query}` : '/admissions/follow-ups'
      );
    },

    async createAdmissionFollowUp(body: CreateAdmissionFollowUpRequest) {
      return client.request<CreateAdmissionFollowUpResponse>('/admissions/follow-ups', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async listAdmissionCounselling(params?: ListAdmissionCounsellingQuery) {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      if (params?.lead_id?.trim()) qs.set('lead_id', params.lead_id.trim());
      const query = qs.toString();
      return client.request<ListAdmissionCounsellingResponse>(
        query ? `/admissions/counselling?${query}` : '/admissions/counselling'
      );
    },

    async createAdmissionCounselling(body: CreateAdmissionCounsellingRequest) {
      return client.request<CreateAdmissionCounsellingResponse>('/admissions/counselling', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async listAdmissionLeadAudits(params?: ListAdmissionLeadAuditsQuery) {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      if (params?.lead_id?.trim()) qs.set('lead_id', params.lead_id.trim());
      const query = qs.toString();
      return client.request<ListAdmissionLeadAuditsResponse>(
        query ? `/admissions/leads/audits?${query}` : '/admissions/leads/audits'
      );
    },

    async convertAdmissionLead(body: ConvertAdmissionLeadRequest) {
      return client.request<ConvertAdmissionLeadResponse>('/admissions/convert', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },
  };
}
